<template>
  <div>
    <h1>Registrar Pago</h1>
    <!-- {{ getConcesionarios }} -->
    <b-row>
      <b-col md="6">
        <a-form-item label="Concesionario">
          <v-select label="name" :options="getConcesionarios" @input="handleConcesionarioSelect" v-model="selectedConcesionario"><span slot="no-options">Elemento no encontrado</span></v-select>
        </a-form-item>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar concesión"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getAllConceciones"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(acciones)="row">
        <b-button class="btn-sm" v-if="row.item.active" variant="outline-danger" @click="showConfirmDisable(row.item)">Deshabilitar</b-button>
        <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="showConfirmEnable(row.item)">Habilitar</b-button>
        <!--<b-button class="btn-sm" variant="outline-success" @click="validateCheckIn(row.item)">checkIn</b-button>-->
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllConceciones.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
const QUERY_GET_ALL_CONCESIONES = gql`
query {
  getAllConceciones{
    id
    concesionNumber
    concesionario{
      name
      rfc
    }
    vehicle{
      id
      brand
      serialNumber
      licensePlate
    }
    active
  }
}`
const GET_CONCESIONARIOS_QUERY = gql`
query{
  getConcesionarios{
    id
    name
    email
  }
}
`
const GET_CONCESIONES_BY_CONCESIONARIO = gql`
query($id: Int){
  getAllConcesionByConcesionario(id: $id){
    id
    concesionNumber
    concesionario{
      name
      rfc
    }
    vehicle{
      id
      brand
      serialNumber
      licensePlate
    }
    active
  }
}
`
export default {
  data() {
    return {
      fields: [
        { key: 'id', label: 'Id ', sortable: true, sortDirection: 'desc' },
        { key: 'concesionNumber', label: 'Número de Concesión' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getAllConceciones: [],
      getConcesionarios: [],
      selectedConcesionario: {},
    }
  },
  apollo: {
    getAllConceciones: {
      query: QUERY_GET_ALL_CONCESIONES,
      error(error) {
        console.log(error)
      },
      result({ data }) {
        if (data.getAllConceciones) {
          this.totalRows = data.getAllConceciones.length
        }
      },
    },
    getConcesionarios: {
      query: GET_CONCESIONARIOS_QUERY,
      error(error) {
        console.log(error)
      },
      result({ data }) {
        console.log(data)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleConcesionarioSelect(concesionario) {
      console.log(concesionario)
      this.$apollo.query({
        query: GET_CONCESIONES_BY_CONCESIONARIO,
        variables: {
          id: concesionario.id,
        },
      })
        .then(({ data }) => {
          console.log(data)
          this.getAllConceciones = data.getAllConcesionByConcesionario
        })
        .catch(error => {
          console.log(error)
        })
      // console.log(concesionario)
    },
  },
}
</script>
